import { useTranslation } from 'react-i18next'
import { EditPanelChat } from './chat'
import { initialGeneratingMessages } from './placeholders'

export function PendingCreateEditArea() {
	const { t } = useTranslation('common')
	return (
		<EditPanelChat
			messages={initialGeneratingMessages(false, t)}
		/>
	)
}
